export const PHONE_NUMBERS = {
  CUSTOMER_SUPPORT: '8774255201',
} as const;

export default PHONE_NUMBERS;
